import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceDestinationInfoDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Ramp Info',
	minWidth: 110,
	width: 110,
	headerName: 'Trc Ramp Info',
	renderHeader: () => <RenderHeader primaryText='Trc Ramp Info' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.trcDestInfo && (
					<span
						className={styles.bold}
						title={row.trcDestInfo}
					>
						{row.trcDestInfo}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcDestInfo } = row;
				return caseInsensitiveIncludes(value, [trcDestInfo]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcDestInfo ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceDestinationInfoDefinition;
